var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h14v14H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#004884",
    d: "M13.539 7.667v7.778h-6.21V7.667h6.21M12.375 3H8.493l-.776.778H5v1.555h10.868V3.778h-2.717zm2.717 3.111H5.776v9.333A1.559 1.559 0 0 0 7.329 17h6.21a1.559 1.559 0 0 0 1.553-1.556z",
    transform: "translate(-3.434 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSmallIcon);
export default __webpack_public_path__ + "static/media/delete_small_icon.b0f139722df2ea0e9defdbb9887cdd51.svg";
export { ForwardRef as ReactComponent };